import { Tag } from 'antd';
import { useIntl } from 'react-intl';

import type {
  IWorkJourneyManagementDayReportItem,
  TWorkJourneyManagementDayReportStatus,
} from '@src/models/interfaces/workJourneyManagement.interface';

import { formatDayReportStatusDetail } from '../../../../utils/formatDayReportStatus';
import styles from './styles.module.less';

interface WorkJourneyDayReportStatusBadgeProps {
  item: Pick<IWorkJourneyManagementDayReportItem, 'status' | 'statusReason'>;
}

const STATUS_COLORS: Record<TWorkJourneyManagementDayReportStatus, string> = {
  present: 'success',
  justified_absence: 'gold',
  unjustified_absence: 'error',
};

export const WorkJourneyDayReportStatusBadge = ({
  item,
}: WorkJourneyDayReportStatusBadgeProps) => {
  const intl = useIntl();
  const label = formatDayReportStatusDetail(item, intl.formatMessage);

  return (
    <Tag
      color={STATUS_COLORS[item.status]}
      className={`gx-mb-0 gx-mr-0 ${styles.badge}`}
      title={label}
    >
      {label}
    </Tag>
  );
};
